import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { UserControllerService } from 'src/app/services/user-controller.service';

class recruiter {
  id: string
  name: string
  lastname: string
}

@Component({
  selector: 'app-recruiter-card',
  templateUrl: './recruiter-card.component.html',
  styleUrls: ['./recruiter-card.component.scss']
})
export class RecruiterCardComponent implements OnInit {

  recruiter_id: string;
  recruiter: recruiter = new recruiter;
  noInfo: boolean = true

  statistics = [
    { name: 'Candidatos reclutados', value: null },
    { name: 'Calificación promedio de los reclutados', value: null },
    { name: 'Porcentaje de aprobación', value: null }
  ];
  displayedColumns = ['name', 'value']

  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl()
  });

  constructor(private route: ActivatedRoute,
    private _recruiters: UserControllerService) { }

  ngOnInit(): void {
    this.route.paramMap.pipe(switchMap(resolve => {
      this.noInfo = true
      this.recruiter_id = resolve.get('id')
      return this._recruiters.getRecruiter({ id: this.recruiter_id })
    })).subscribe
      (resolve => {
        this.recruiter = resolve[0]
      })
  }

  loadInfo(): void {
    if (this.range.controls.start.hasError('matDatepickerParse') ||
      this.range.controls.end.hasError('matDatepickerParse') || 
      this.range.value.start == null || this.range.value.end == null) return
    this._recruiters.getRecruiterInfo({id: this.recruiter_id, range:this.range.value}).subscribe(response => {
      if (response[0].count == 0) return
      this.noInfo = false
      this.statistics[0].value = response[0].count
      this.statistics[1].value = response[0].avg
      this.statistics[2].value = response[0].avg_passed + ' %'

    })
  }

}
